/* 
 * listings filter js component
 */

import _Abstract from "system/abstract"
export default class Component_ArticleFilter extends _Abstract {
  constructor(el, options) 
  {
    super(el, $.extend(true, 
    {
      filterAttrItem:'data-item-filters',
      filterAttrFilter:'data-filter-by'

    },options), 'component')


    this.$el.addClass("c-listings-filter");

    this.searchBoxDebounceTimer = null;
    this.dataFilterSearchTerm = "";
    
    this.INDEPENDENT_SEARCH_AND_FILTER = true;

    this.$filterItems = this.$el.find('[' + this.options.filterAttrItem + ']');
    this.$filters = this.$el.find('[' + this.options.filterAttrFilter + ']');
    this.filterByArray = [];
    this.$clearFiltersBtn = this.$el.find('.js-clear-filters');
    this.bindEvents();


    this.initialiseFilterFromURLParamater();
  }

  bindEvents() 
  {
    // on filter click
    this.$filters.on('click',(e) => this.onFilterClicked(e));
    this.$clearFiltersBtn.on('click',(e)=> this.onClearFilterButtonClicked(e));
    this.$el.find(".c-search-input--input").on("keyup",(e) => this.onSearchInputKeyUp(e));
    this.$el.find(".c-search-input--input").on("keydown",(e) => this.onSearchInputKeyDown(e));
    // this.$el.find(".c-search-input--input").on("keydown",(e) => this.onSearchInputKeyDown(e));
    this.$el.find(".c-search-input__search-btn").click((e) => this.onSearchBtnClicked(e));


  }

  //http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  getParameterByName(name, url)
  {
    if (!url)
    {
      url = window.location.href;
    }

    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results)
    {
      return null;
    }

    if (!results[2])
    {
      return '';
    }
    
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  initialiseFilterFromURLParamater()
  {
    var filterValue = this.getParameterByName("filter");
    if(!filterValue)
    {
      return;
    }
    
    $(".c-article-filters > button").each(function()
    {
      if($(this).text().toLowerCase() === filterValue.toLowerCase())
      {
        $(this).click();
        return false;
      }
    });

  }

  onSearchInputKeyDown(_keyboardEvent)
  {
      switch(_keyboardEvent.keyCode)
      {
        case 13: //enter
        {
          _keyboardEvent.preventDefault();
          return false;
          break;
        }
      }
  }

  onSearchInputKeyUp(_keyboardEvent)
  {
      console.log('on key up');
      // this.resetSearchBoxDebounceTimer();
          this.dataFilterSearchTerm = _keyboardEvent.target.value;
      if($(_keyboardEvent.target).closest(".c-mobile-sub-page").length)
      {
          $(".m-articles .c-search-input .c-search-input--input").val(this.dataFilterSearchTerm);
      }

      switch(_keyboardEvent.keyCode)
      {
        case 13: //enter
        {
          this.onEnterPressed(_keyboardEvent);
          _keyboardEvent.preventDefault();
          _keyboardEvent.stopPropagation();
          break;
        }
      }
  }

  onSearchInputKeyDown(_keyboardEvent)
  {
      console.log('on key down');
      // this.clearSearchBoxDebounceTimer();
  }


  onSearchBtnClicked(_mouseEvent)
  {
    this.forceSearch();
  }

  onEnterPressed(_keyboardEvent)
  {
    this.forceSearch();
    if($(_keyboardEvent.target).closest(".c-mobile-sub-page").length)
    {
      $(".c-mobile-sub-page .c-mobile-sub-page__header-back-btn").click();
    }

  }

  forceSearch()
  {
    if(this.INDEPENDENT_SEARCH_AND_FILTER)
    {
        this.clearFilters();
        this.resetFilter();
    }
    this.clearSearchBoxDebounceTimer();
    this.onKeyboardSearchDebounceExpired();
 
  }



  resetSearchBoxDebounceTimer()
  {
    this.clearSearchBoxDebounceTimer();

    this.searchBoxDebounceTimer = window.setTimeout(() => this.onKeyboardSearchDebounceExpired(),1000);
  }

  onKeyboardSearchDebounceExpired()
  {
    this.searchBoxDebounceTimer = null;
    // this.dataFilterSearchTerm = this.$el.find(".c-search-input--input").val();

    this.updateItems(this.filterByArray,true);
  }

  clearSearchBoxDebounceTimer()
  {
      if(!this.searchBoxDebounceTimer)
      {
          return;
      }
      
      window.clearTimeout(this.searchBoxDebounceTimer);
      this.searchBoxDebounceTimer = null;
  }


  getAllFilterItems()
  {
    return this.$el.find('[' + this.options.filterAttrItem + ']');
  }

  getAllFilters()
  {
    return $(".c-article-filters").find('[' + this.options.filterAttrFilter + ']');
  }

  isClickEventInMobileSubPage(e)
  {
      return $(e.target).closest(".c-mobile-sub-page").length;
  }

  onFilterClicked(e)
  {
    e.preventDefault();


    if(this.INDEPENDENT_SEARCH_AND_FILTER)
    {
      this.clearSearchBoxDebounceTimer();
      this.$el.find(".c-search-input--input").val("");
      this.dataFilterSearchTerm = "";
    }

    var index = $(e.target).index();
    

    //More then one may exist (mobile sub page for example)
    var $clickedTarget = $(e.target);
    var bCurrentlySelected = $clickedTarget.hasClass("-selected") || $clickedTarget.hasClass("-active");
    var filterStr = $clickedTarget.attr(this.options.filterAttrFilter);

    $(".c-article-filters").each(function()
    {
        var $buttonsIndexOfClickedItem = $(this).find(" > :nth-child("+(index+1)+")");
        // get target id to filter by

        //if filter is selected remove target id from filter array
        if(bCurrentlySelected)
        {
          $buttonsIndexOfClickedItem.removeClass('-selected').removeClass('-active');
        }
        else //if filter is not selected add target id to filter array
        {
          $buttonsIndexOfClickedItem.addClass('-selected').addClass("-active");
        }

    });

    if(bCurrentlySelected)
    {
      this.filterByArray.splice(this.getIndexOfItem(this.filterByArray,filterStr),1);
    }
    else
    {
      this.filterByArray.push(filterStr);
    }

    //update filtered items
    this.updateItems(this.filterByArray);
  }

  onClearFilterButtonClicked(e)
  {
    e.preventDefault();
    this.clearFilters();
    this.resetFilter();
    this.updateItems(this.filterByArray);
  }

  resetFilter()
  {
    //show all items
    this.filterByArray = [];
    $('.js-clear-filters').addClass('-selected').addClass('-active');

  }

  clearFilters()
  {
    this.getAllFilters().removeClass('-selected').removeClass('-active');
  }

  updateItems(arrayOfFilteredItems,bSearchTermTriggered)
  {

    if(typeof bSearchTermTriggered === "undefined")
    {
      bSearchTermTriggered = false;
    }

    //pass array to function that shows/hides items based on match
    this.hideFilteredItem(arrayOfFilteredItems,bSearchTermTriggered);

  }

  getIndexOfItem(array,str)
  {

    // get index of item in array
    var index = array.indexOf(str);
    return index;

  }


  hideFilteredItem(arrayOfFilterBy, bSearchTermTriggered)
  {
    if(typeof bSearchTermTriggered === "undefined")
    {
      bSearchTermTriggered = false;
    }

    var dataFilterSearchTerm = this.dataFilterSearchTerm;
    //items that match current array, use filter to determine match

    if(arrayOfFilterBy.length || dataFilterSearchTerm)
    {
      var $itemsThatMatch = this.$filterItems.filter(function(index)
      {
        //set match to false
        var match = false;

        //loop array of target ids to filter by
        $.each(arrayOfFilterBy,(index,filterId)=>{

          // if target id str is found in items filter attribute set to true
          if($(this).is("[data-item-filters*='" + filterId + "']"))
          {
            match = true;
          }
        
        });



        if(dataFilterSearchTerm)
        {
          var searchTermMatches = $(".c-tile--title:containsNoCase('"+dataFilterSearchTerm+"'), .c-tile-description:containsNoCase('"+dataFilterSearchTerm+"')",this).length;
          if(!searchTermMatches)
          {
            return false;
          }

          //If there's no filter selected, then we're filtering by all, so return a match
          if(!arrayOfFilterBy.length)
          {
              return true;
          }

        }


        // return match true|false
        return match;
      });
      
    }
    else
    {
      var $itemsThatMatch = this.$filterItems;
    }

    //items that do not match
    var hideItems = this.$filterItems.not($itemsThatMatch);
    //if no flters are selected and tehre are no items in arary, show all items by default
    if(arrayOfFilterBy.length <= 0 && !dataFilterSearchTerm)
    {
      this.resetFilter();
    }


    if(arrayOfFilterBy.length > 0)
    {
        $('.js-clear-filters').removeClass('-selected').removeClass('-active');
    }

    var context = this;
    $(".m-two-col-vertically-stacked-tiles ").fadeOut(function()
    {
        var $noResultsFoundFromSearchElement = $(".-no-results-found-from-search-filter-element");
        context.$filterItems.addClass("-hide");
        if($itemsThatMatch.length)
        {
          $noResultsFoundFromSearchElement.addClass("-hide");    
          $itemsThatMatch.removeClass("-hide");
          $(".m-two-col-vertically-stacked-tiles ").show();
          $("body").trigger("reorder-items");
          $(".m-two-col-vertically-stacked-tiles ").hide();
        }
        else
        {
          $noResultsFoundFromSearchElement.removeClass("-hide");    
        }

        $(".m-two-col-vertically-stacked-tiles ").fadeIn();

    });

  }
}



/** WEBPACK FOOTER **
 ** ./components/article-filter.js
 **/